/**
 * View component for /my-agenda/sponsor/:sponsorId
 *
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import actions
import * as moduleCertificateActions from '../../moduleCertificate/moduleCertificateActions';
import * as sponsorActions from '../../sponsor/sponsorActions';
import * as contentModuleActions from '../../contentModule/contentModuleActions';
import * as userModuleActions from '../../userModule/userModuleActions';

// import global components
import { SearchInput } from '../../../global/components/forms';
import Base from '../../../global/components/BaseComponent.js.jsx';
import StudyLayout from '../../study/components/StudyLayout.js.jsx';

// import components 
import AgendaTmListItem from '../components/AgendaTmListItem.js.jsx';
import SponsorAgendaManager from '../components/SponsorAgendaManager.js.jsx';
// not updating links here because this should no longer be used with london handling agenda

class SponsorAgenda extends Base {
  constructor(props) {
    super(props);
    this.state = {
      queryText: ''
    }
    this._bind(
      '_handleQuery'
    )
  }

  componentDidMount() {
    const { dispatch, loggedInUser, match } = this.props;

    // redirect to london
    window.location.replace(`${window.agendaUrl}/${match.params.sponsorId}`);

    dispatch(sponsorActions.fetchSingleIfNeeded(match.params.sponsorId));
    dispatch(moduleCertificateActions.fetchListIfNeeded('_user', loggedInUser._id));
    // dispatch(contentModuleActions.fetchListIfNeeded('programs-grouped-with-sponsor-agenda', match.params.sponsorId))
    dispatch(userModuleActions.fetchList('_user', loggedInUser._id));
  }

  _handleQuery(e) {
    this.setState({
      [e.target.name]: e.target.value.toLowerCase()
    });
  }

  render() {
    const {
      loggedInUser
      , match
      , moduleCertificateStore
      , sponsorStore 
      , contentModuleStore 
      , userModuleStore
    } = this.props;

    const selectedSponsor = sponsorStore.selected.getItem();

    
    const isEmpty = (
      !selectedSponsor
      || !selectedSponsor._id
    );

    const isFetching = (
      sponsorStore.selected.isFetching 
    )

    return(
      <StudyLayout>
        <Helmet
          title={"Sponsor List | Pro-ficiency"}
        /> 
        <div className="flex">
          <section className="section my-agenda -program">
            {/* <div className="-content-wrapper"> */}
            <div className="yt-container">
            { isEmpty ?
                (isFetching ?
                  <div className="u-centerText">
                    <div className="loading"></div>
                  </div>
                :
                  <div className="u-centerText">
                    <h2>No programs were found!</h2>
                    <p>Please <Link to="/contact-us">contact</Link> your administrator if you feel this was an error.</p>
                    <p>Or navigate to your <Link to="/my-agenda">Agenda</Link> to try another program!</p>
                  </div>
                )
                :
                <div style={{ opacity: isFetching ? 0.5 : 1 }}>
                  <SponsorAgendaManager
                    showAllGrouped={true}
                    showOptional={true}
                    sponsor={selectedSponsor}
                  />
                </div>
              }
            </div>
          </section>
        </div>
      </StudyLayout>
    )
  }
}


SponsorAgenda.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    loggedInUser: store.user.loggedIn.user
    , moduleCertificateStore: store.moduleCertificate
    , sponsorStore: store.sponsor
    , contentModuleStore: store.contentModule
    , userModuleStore: store.userModule 
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SponsorAgenda)
);



// WEBPACK FOOTER //
// modules/agenda/views/SponsorAgenda.js.jsx